import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PageMeta from '../../components/common/PageMeta';
import { Button, Row } from '../../ui/v2';
import IntegrationResult from './IntegrationResult';

const ERROR_MESSAGES: Record<string, string> = {
  access_denied:
    'You declined the authorization request. No changes were made.',
  connection_setup_incomplete:
    'The connection could not be fully activated. This may be a temporary issue — please try again.',
  invalid_state:
    'The authorization session expired or was invalid. Please restart the connection process.',
  token_exchange_failed:
    'We could not complete the authorization with your POS provider. Please try again.',
};

export default function PosCallbackError() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const errorCode = searchParams.get('error') || 'unknown';
  const errorDetail = searchParams.get('detail');
  const friendlyMessage =
    ERROR_MESSAGES[errorCode] ||
    'Something went wrong during the POS connection. Please try again or contact support.';

  return (
    <>
      <PageMeta
        title="Connection Failed | Ask Arthur"
        description="POS integration error"
      />
      <IntegrationResult
        tone="danger"
        title="Connection failed"
        message={friendlyMessage}
        details={
          errorCode !== 'unknown' || errorDetail ? (
            <>
              <Row label="Error">
                <span className="break-all font-mono text-v2-12">
                  {errorCode}
                </span>
              </Row>
              {errorDetail && <Row label="Detail">{errorDetail}</Row>}
            </>
          ) : undefined
        }
        actions={
          <>
            <Button variant="primary" onClick={() => navigate('/integrations')}>
              Try again
            </Button>
            <a
              href="mailto:support@askarthur.io"
              className="text-v2-13 font-medium text-v2-accent hover:underline"
            >
              Contact support
            </a>
          </>
        }
      />
    </>
  );
}
